import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { type IResponseNumber } from 'entities/Phone/api/types'

type IRejectAssignedNumbersAlertProps = {
  airCallLink: string
  rejectAssignedNumbers: Pick<IResponseNumber, 'formatted_number'>[]
  clearRejectAssignedNumbers: () => void
  rejectMessage?: string | null
}

export const RejectAssignedNumbersAlert = observer(
  ({
    airCallLink,
    rejectAssignedNumbers,
    clearRejectAssignedNumbers,
    rejectMessage,
  }: IRejectAssignedNumbersAlertProps) => {
    if (!rejectAssignedNumbers.length && !rejectMessage) return null

    const title =
      rejectMessage ??
      (rejectAssignedNumbers.length > 1
        ? 'These numbers couldn’t be assigned'
        : 'This number couldn’t be assigned. Aircall number is not 10DLC/Toll-Free compliant.')

    const desc = rejectMessage
      ? null
      : rejectAssignedNumbers?.map((number) => number.formatted_number).join(', ')

    return (
      <Alert
        item={{
          type: 'alert',
          title,
          desc,
        }}
        onClose={clearRejectAssignedNumbers}
        marginBottom={8}
        rightActions={
          airCallLink && !rejectMessage
            ? [
                {
                  variant: 'link',
                  type: 'primary',
                  text: 'Contact Aircall',
                  link: airCallLink,
                },
              ]
            : undefined
        }
      />
    )
  }
)
